import { AssetIcon } from 'assets/icons/AssetIcon';
import cx from 'classnames';
import Button from 'components/button/Button';
import { MAX_LENGTH_COUPON } from 'constants/common.const';
import { map, range, size } from 'lodash';
import React, { HTMLAttributes, useCallback, useState } from 'react';
import { KEYBOARD_CHARACTERS } from './keyboard-util';
import './keyboard.css';

export type KeyboardProps = HTMLAttributes<HTMLDivElement> & {
  value: string;
  maxLength?: number;
  loading?: boolean;
  isNumeric?: boolean;
  handleChange?: (val: string) => void;
  handleEnter?: () => void;
};

export const Keyboard: React.FC<KeyboardProps> = ({
  value,
  maxLength = MAX_LENGTH_COUPON,
  loading = false,
  isNumeric = false,
  handleChange,
  handleEnter,
  ...props
}) => {
  const [isUpperCase, setIsUpperCase] = useState(true);

  const handleTyping = (text: string) => () => {
    size(`${value}${text}`) < maxLength && handleChange?.(`${value}${text}`);
  };

  const handleBackspace = () => {
    !!value && handleChange?.(value.substring(0, size(value) - 1));
  };

  const handleToggleUpperCase = () => {
    setIsUpperCase(!isUpperCase);
  };

  const getKeyboardCharacter = useCallback(
    (characters: string[]) =>
      !isUpperCase
        ? characters
        : map(characters, (c: string) => c.toUpperCase()),
    [isUpperCase],
  );

  if (isNumeric)
    return (
      <div
        {...props}
        className={cx(
          'alphaKeyboard alphaKeyboard--numberic no-select',
          props?.className,
        )}
      >
        {map(range(1, 4), (lineKey) => (
          <div className="alphaKeyboard--line">
            {map(range(1, 4), (key) => {
              const num = (lineKey - 1) * 3 + key;

              return (
                <Button
                  key={`${num}`}
                  onClick={handleTyping(`${num}`)}
                  isFillWhenCustomerHover
                >
                  {num}
                </Button>
              );
            })}
          </div>
        ))}
        <div className="alphaKeyboard--line">
          <Button
            className="alphaKeyboard-backSpace"
            onClick={handleBackspace}
            variantFill
          >
            <AssetIcon.BackSpaceIcon />
          </Button>
          <Button key="0" onClick={handleTyping('0')} isFillWhenCustomerHover>
            0
          </Button>
          <Button
            className="alphaKeyboard-enter"
            onClick={handleEnter}
            loading={loading}
            disabled={loading}
            variantFill
          >
            Enter
          </Button>
        </div>
      </div>
    );

  return (
    <div {...props} className={cx('alphaKeyboard no-select', props?.className)}>
      <div className="alphaKeyboard--line">
        {map(getKeyboardCharacter(KEYBOARD_CHARACTERS.LINE_NUM), (key) => (
          <Button key={key} onClick={handleTyping(key)}>
            {key}
          </Button>
        ))}
        <Button
          className="alphaKeyboard-backSpace"
          onClick={handleBackspace}
          variantFill
        >
          <AssetIcon.BackSpaceIcon />
        </Button>
      </div>
      <div className="alphaKeyboard--line">
        {map(getKeyboardCharacter(KEYBOARD_CHARACTERS.LINE1), (key) => (
          <Button key={key} onClick={handleTyping(key)}>
            {key}
          </Button>
        ))}
      </div>
      <div className="alphaKeyboard--line">
        {map(getKeyboardCharacter(KEYBOARD_CHARACTERS.LINE2), (key) => (
          <Button key={key} onClick={handleTyping(key)}>
            {key}
          </Button>
        ))}
      </div>
      <div className="alphaKeyboard--line">
        <Button
          className={cx('shift-key', {
            'shift-key-active': isUpperCase,
          })}
          variantFill
          onClick={handleToggleUpperCase}
        >
          <AssetIcon.Shift />
        </Button>
        {map(getKeyboardCharacter(KEYBOARD_CHARACTERS.LINE3), (key) => (
          <Button key={key} onClick={handleTyping(key)}>
            {key}
          </Button>
        ))}
        <Button
          className="alphaKeyboard-enter"
          onClick={handleEnter}
          loading={loading}
          disabled={loading}
          variantFill
        >
          Enter
        </Button>
      </div>
      {/* <div className="alphaKeyboard--line1">
        <Button className="alphaKeyboard-space" onClick={handleTyping(' ')}>
          Space
        </Button>
        <Button
          className="alphaKeyboard-enter"
          onClick={handleEnter}
          loading={loading}
          disabled={loading}
          variantFill
        >
          Enter
        </Button>
      </div> */}
    </div>
  );
};
